<!-- Notifications toggle -->
<button mat-icon-button (click)="openPanel()" #notificationsOrigin>
  <ng-container *ngIf="unreadCount > 0">
    <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3">
      <span
        class="flex items-center justify-center shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full text-white text-xs font-medium"
        style="background-color: #e77e2e;">
        {{ unreadCount }}
      </span>
    </span>
  </ng-container>
  <mat-icon [svgIcon]="'heroicons_outline:bell'"></mat-icon>
</button>

<!-- Notifications panel -->
<ng-template #notificationsPanel>
  <div class="fixed rounded-md inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-90 sm:w-90 overflow-hidden shadow-lg">
    <!-- Header -->
    <div class="flex shrink-0 items-center mt-2 py-2 pr-4 pl-6" style="background: #eef2ff; border: 1px solid #dbe0ef">
      <div class="sm:hidden -ml-1 mr-3">
        <button mat-icon-button (click)="closePanel()">
          <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
        </button>
      </div>
      <div class="text-lg font-medium text-secondary">{{ 'Notifications' | translate }}</div>
      <div class="ml-auto">
        <button
          class="text-[11px] font-medium px-2 py-1 rounded transition-colors bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200"
          [disabled]="unreadCount === 0"
          [class.opacity-40]="unreadCount === 0"
          [class.cursor-not-allowed]="unreadCount === 0"
          (click)="confirmMarkAllAsDone()">
          Mark all as Done
        </button>
      </div>
    </div>

    <div class="flex items-center gap-1 px-4 py-1.5 border-b bg-white dark:bg-gray-800 flex-shrink-0">
      <span class="text-[10px] text-gray-400 mr-1">View:</span>
      <button
        class="px-2 py-0.5 text-[11px] font-medium rounded transition-colors"
        [class.bg-primary-500]="notificationView === 'open'"
        [class.text-white]="notificationView === 'open'"
        [class.bg-gray-100]="notificationView !== 'open'"
        [class.dark:bg-gray-700]="notificationView !== 'open'"
        [class.text-gray-600]="notificationView !== 'open'"
        [class.dark:text-gray-300]="notificationView !== 'open'"
        (click)="setNotificationView('open')">
        Open
      </button>
      <button
        class="px-2 py-0.5 text-[11px] font-medium rounded transition-colors"
        [class.bg-primary-500]="notificationView === 'all'"
        [class.text-white]="notificationView === 'all'"
        [class.bg-gray-100]="notificationView !== 'all'"
        [class.dark:bg-gray-700]="notificationView !== 'all'"
        [class.text-gray-600]="notificationView !== 'all'"
        [class.dark:text-gray-300]="notificationView !== 'all'"
        (click)="setNotificationView('all')">
        All
      </button>
      <span class="text-[10px] text-gray-400 ml-3 mr-1">Grouped:</span>
      <button
        class="px-2 py-0.5 text-[11px] font-medium rounded transition-colors"
        [class.bg-primary-500]="notificationGroupBy === 'student'"
        [class.text-white]="notificationGroupBy === 'student'"
        [class.bg-gray-100]="notificationGroupBy !== 'student'"
        [class.dark:bg-gray-700]="notificationGroupBy !== 'student'"
        [class.text-gray-600]="notificationGroupBy !== 'student'"
        [class.dark:text-gray-300]="notificationGroupBy !== 'student'"
        (click)="setNotificationGroupBy('student')">
        Student
      </button>
      <button
        class="px-2 py-0.5 text-[11px] font-medium rounded transition-colors"
        [class.bg-primary-500]="notificationGroupBy === 'ungrouped'"
        [class.text-white]="notificationGroupBy === 'ungrouped'"
        [class.bg-gray-100]="notificationGroupBy !== 'ungrouped'"
        [class.dark:bg-gray-700]="notificationGroupBy !== 'ungrouped'"
        [class.text-gray-600]="notificationGroupBy !== 'ungrouped'"
        [class.dark:text-gray-300]="notificationGroupBy !== 'ungrouped'"
        (click)="setNotificationGroupBy('ungrouped')">
        Ungrouped
      </button>
      <div class="ml-auto text-[10px] text-gray-500">
        {{ notificationTotal }}
      </div>
    </div>

    <!-- Content -->
    <div class="relative flex flex-col flex-auto sm:max-h-120 divide-y overflow-y-auto bg-card">
      <!-- Grouped by Student -->
      <ng-container *ngIf="notifications?.length && notificationGroupBy === 'student'">
        <ng-container *ngFor="let group of pagedNotificationsByStudent; trackBy: trackGroupByFn">
          <div
            class="flex items-center gap-3 py-3 px-4 hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5 cursor-pointer border-b border-gray-100 dark:border-gray-700"
            (click)="onStudentGroupClick(group)">
            <div class="flex flex-0 items-center justify-center w-10 h-10 rounded-full bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-300 text-lg font-semibold uppercase shrink-0">
              {{ group.studentName?.charAt(0) || '?' }}
            </div>
            <div class="flex-1 min-w-0">
              <div class="font-medium text-sm truncate">{{ group.studentName }}</div>
              <div class="text-xs text-gray-500 dark:text-gray-400 truncate" *ngIf="group.companyName">{{ group.companyName }}</div>
            </div>
            <div class="flex items-center gap-2 shrink-0">
              <span
                class="flex items-center justify-center min-w-6 h-6 px-1.5 rounded-full text-xs font-bold text-white"
                style="background-color: #e77e2e;">
                {{ group.count > 99 ? '99+' : group.count }}
              </span>
              <button
                class="text-[10px] font-medium px-2 py-0.5 rounded whitespace-nowrap transition-colors bg-blue-50 hover:bg-blue-100 text-blue-700 border border-blue-200"
                (click)="onStudentGroupClick(group); $event.stopPropagation()"
                matTooltip="Go to supervisor review">
                Go to
              </button>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <!-- Ungrouped: flat list -->
      <ng-container *ngIf="notifications?.length && notificationGroupBy === 'ungrouped'">
        <ng-container *ngFor="let notification of notifications; trackBy: trackByFn">
          <div class="flex group hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5" [ngClass]="{ unread: !notification.read }">
            <div class="flex text-sm flex-auto py-2.5 pl-4">
              <ng-container *ngTemplateOutlet="notificationContentTpl; context: { $implicit: notification }"></ng-container>
            </div>
            <div class="flex flex-col items-end justify-center gap-1 my-2 mr-3 ml-1 flex-shrink-0">
              <button
                *ngIf="!notification.read"
                class="text-[10px] font-medium px-2 py-0.5 rounded whitespace-nowrap transition-colors bg-amber-50 hover:bg-amber-100 text-amber-700 border border-amber-200"
                (click)="confirmMarkAsDone(notification)"
                matTooltip="Mark this notification as done">
                Done
              </button>
              <span
                *ngIf="notification.read"
                class="text-[10px] text-gray-400 px-2 py-0.5 italic">
                done
              </span>
              <button
                class="text-[10px] font-medium px-2 py-0.5 rounded whitespace-nowrap transition-colors bg-blue-50 hover:bg-blue-100 text-blue-700 border border-blue-200"
                (click)="onNotificationClick(notification)"
                matTooltip="Go to this step">
                Go to
              </button>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <!-- Notification content template (for ungrouped view) -->
      <ng-template #notificationContentTpl let-notification>
        <ng-container *ngIf="notification">
          <ng-container *ngIf="notification.icon && !notification.image">
            <div class="flex shrink-0 items-center justify-center w-8 h-8 mr-4 rounded-full bg-gray-100 dark:bg-gray-700">
              <mat-icon class="icon-size-5" [svgIcon]="notification.icon"></mat-icon>
            </div>
          </ng-container>
          <ng-container *ngIf="notification.image">
            <img class="shrink-0 w-8 h-8 mr-4 rounded-full overflow-hidden object-cover object-center" [src]="notification.image" alt="Notification image" />
          </ng-container>
          <div class="flex flex-col flex-auto">
            <ng-container *ngIf="notification.title">
              <div class="font-semibold text-sm line-clamp-1" [innerHTML]="notification.title"></div>
            </ng-container>
            <ng-container *ngIf="notification.description">
              <div class="text-sm text-gray-600 dark:text-gray-400 line-clamp-2" [innerHTML]="notification.description"></div>
            </ng-container>
            <div class="flex flex-wrap gap-1 mt-1" *ngIf="notification.company_name">
              <span class="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">{{ notification.company_name }}</span>
            </div>
            <div class="mt-1 text-xs leading-none text-secondary">{{ notification.time | date: 'MMM dd, h:mm a' }}</div>
          </div>
        </ng-container>
      </ng-template>

      <!-- No notifications -->
      <ng-container *ngIf="!notifications || !notifications.length">
        <div class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
          <div class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100 dark:bg-primary-600">
            <mat-icon class="text-primary-700 dark:text-primary-50" [svgIcon]="'heroicons_outline:bell'"></mat-icon>
          </div>
          <div class="mt-5 text-2xl font-semibold tracking-tight">{{ 'No notifications' | translate }}</div>
          <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">
            {{ 'When you have notifications, they will appear here' | translate }}.
          </div>
        </div>
      </ng-container>
    </div>

    <div class="flex items-center justify-between px-3 py-1.5 border-t bg-white dark:bg-gray-800 flex-shrink-0">
      <!-- Grouped mode: paginate student groups client-side -->
      <ng-container *ngIf="notificationGroupBy === 'student'">
        <button mat-icon-button (click)="previousGroupPage()" [disabled]="groupPage <= 1">
          <mat-icon [svgIcon]="'heroicons_outline:chevron-left'"></mat-icon>
        </button>
        <span class="text-xs text-gray-600 dark:text-gray-400">{{ groupPage }} / {{ groupTotalPages }}</span>
        <button mat-icon-button (click)="nextGroupPage()" [disabled]="groupPage >= groupTotalPages">
          <mat-icon [svgIcon]="'heroicons_outline:chevron-right'"></mat-icon>
        </button>
      </ng-container>
      <!-- Ungrouped mode: paginate notifications server-side -->
      <ng-container *ngIf="notificationGroupBy === 'ungrouped'">
        <button mat-icon-button (click)="previousNotificationPage()" [disabled]="notificationPage <= 1">
          <mat-icon [svgIcon]="'heroicons_outline:chevron-left'"></mat-icon>
        </button>
        <span class="text-xs text-gray-600 dark:text-gray-400">{{ notificationPage }} / {{ notificationTotalPages }}</span>
        <button mat-icon-button (click)="nextNotificationPage()" [disabled]="notificationPage >= notificationTotalPages">
          <mat-icon [svgIcon]="'heroicons_outline:chevron-right'"></mat-icon>
        </button>
      </ng-container>
    </div>
  </div>
</ng-template>
